import { defineType } from 'sanity';

export const intro = defineType({
    name: 'intro',
    title: 'Intro section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'subtitle',
            title: 'Subtitle',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'ctaText',
            title: 'CTA Button Text',
            type: 'localizedString',
        },
        {
            name: 'secondaryCtaText',
            title: 'Secondary CTA Button Text',
            type: 'localizedString',
        },
        {
            name: 'image',
            title: 'Image',
            type: 'seoOptimizedImageUrl',
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Intro Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
